import ConsultationInfo from './ConsultationInfo';

export default ConsultationInfo;
